module.exports = __webpack_public_path__ + "img/powered-by-payje-dark.b8c825b3.svg";